import { render, staticRenderFns } from "./ProductItemList.vue?vue&type=template&id=9c36acca&scoped=true"
import script from "./ProductItemList.vue?vue&type=script&lang=js"
export * from "./ProductItemList.vue?vue&type=script&lang=js"
import style0 from "./ProductItemList.vue?vue&type=style&index=0&id=9c36acca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c36acca",
  null
  
)

export default component.exports